  <template >
  <div>
  <div>
  <div class="formPosition">
    <v-card style="margin:auto;" width="1200" >
    <v-card-title style="background-color:#006699;color:white;"></v-card-title>
    <v-progress-linear  style="margin : 0 auto ; height:10px" :indeterminate="isLoading" v-show="isLoading  "></v-progress-linear>

    <v-data-table    :headers="headers"  :items="turmas" :search="searchInDb" :items-per-page="8" sort-by="data_"   class="elevation-3" >
      <template v-slot:top>
        <v-toolbar flat color="white">

        <v-btn @click="openDialog()" style="background-color:#006699;color:white;" outlined> <v-icon md color="white darken-2">add</v-icon> Registrar Turma </v-btn >

          <v-divider class="mx-8" inset vertical></v-divider>
          <v-toolbar-title>Consultar turmas registradas</v-toolbar-title>
          <v-divider class="mx-8" inset vertical></v-divider>
          <!--  search  -->
          <div class="flex-grow-1"></div>
          <v-btn  v-if="searchInDb"  @click="initialize(searchInDb)" text icon color="green">
              <v-icon>cached</v-icon>
            </v-btn>
          <v-text-field
            v-model="searchInDb"
            append-icon="search"
            label="Pesquisa"
            single-line
            hide-details
          ></v-text-field>
          <!-- end  search  -->
        </v-toolbar>
      </template>
      <template v-slot:item.preco="{ item }">
        <span>{{utilitarios.IntegerToMoneyValueFatura(item.preco)}}</span>
      </template>
      <template v-slot:item.action="{ item }">
        <v-menu
          bottom
          origin="center center"
          transition="scale-transition"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              fab dark small
              color="#006699"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon dark>menu</v-icon>
            </v-btn>
          </template>
          <v-list>
              <v-list-item @click="SetEditItem(item)"><v-icon color="#006699" small  >edit</v-icon>Editar</v-list-item>
              <v-list-item @click="setEliminar(item)"><v-icon color="red" small  >delete</v-icon>Eliminar</v-list-item>
          </v-list>
        </v-menu>
      </template>
      <template v-slot:no-data>
     <!--   <v-btn color="primary" @click="initialize">Reset</v-btn>  -->
     Clica em + para adicionar novo estudante
      </template>
    </v-data-table>
    </v-card>
 


    <!-- ============================== DIALOGO Para salvar uma turma ====================== -->


      <template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      persistent
      max-width="600px"
    >
  <v-form
    ref="form"
  v-model="valid"
  lazy-validation
  >
      <v-card>
        <v-overlay :value="overlay">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-card-title style="background-color:#006699;color:white;">
          <span class="text-h5">Registrar Nova turma</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                cols="12"
                sm="6"
                md="6"
              >
                 <v-combobox
                    v-model="turma_obj.curso"
                    :rules="ruleRequired"
                    item-value="idCurso"
                    item-text="descricao"
                    :items="cursos"
                    @change="loadclasse()"
                      chips
                    label="Selecione o Curso"
                  ></v-combobox>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="6"
              >
               <v-combobox
                  v-model="turma_obj.classe"
                  :rules="ruleRequired"
                  item-value="pkAnoacademico"
                  item-text="descricao"
                  :items="classesFiltered"
                  @change="criarTurmaDescricao()"
                  chips
                  label="Selecione a Classe"
                ></v-combobox>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="6"
              >
                <v-text-field
                  v-model="turma_obj.sala"
                  label="Sala"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="6"
              >
               <v-combobox
                  v-model="turma_obj.periodo"
                  :rules="ruleRequired"
                  item-value="id"
                  item-text="descricao"
                  :items="periodos"
                  @change="criarTurmaDescricao()"
                  chips
                  label="Período"
                ></v-combobox>
              </v-col>
              <span style="font-weight:bold">Descrição: {{this.turma_obj.descricao}}</span>
            </v-row>
          </v-container>
          <small>*Preencha correctamente os campos</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="black darken-1"
            text
            @click="dialog = false"
          >
            fechar
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="Guardar()"
          >
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
  </v-form>
    </v-dialog>
  </v-row>
  </template>
    <!-- ===================================================================================== -->
  </div>
</div>
</div>
</template>
 <script>
import Swal from 'sweetalert2'
 import axios from '../../plugins/axios'
 import utilitarios from '../../plugins/utilitarios'
 const ls = require('local-storage')
 export default {

    data: () => ({
      valid: true,
      headers: [
      {
        text: 'Descrição',
        align: 'left',
        sortable: false,
        value: 'descricao'
      },
      { text: 'Curso', value: 'curso' },
      { text: 'Classe', value: 'classe' },
      { text: 'Período', value: 'periodo' },
      { text: 'Data criação', value: 'data_' },
      { text: 'Autor', value: 'autor' }
      ],
      turmas: [],
      classes:[],
      classesFiltered: [],
      searchInDb: '',
      cursos:[],
      periodos:[
        {id:"M",descricao:'Manhã'},
        {id:'T',descricao:'Tarde'},
        {id:'N', descricao:'Noite'}
      ],
      dialog: false,
      overlay: false,
      turma_obj:{
        curso:'',
        classe:'',
        sala:'',
        periodo:'',
        descricao:''
      },
      turma_objDefault:{
        curso:'',
        classe:'',
        sala:'',
        periodo:'',
        descricao:''
      },
      ruleRequired: [value => !!value || 'campo obrigatorio'],
    }),

    created(){
      this.initializeTurmas()
      this.initializeCursos()
      this.initializeClasses()
    },

    computed: {
      anolectivo () {
         return ls.get('anolectivo')
      },
      Integrado () {
        return ls.get('integrado') === '1'
      },
    },

    methods: {

      closeDialog (){
        this.dialog = false
        this.turma_obj = this.turma_objDefault
        this.$refs.form.resetValidation()
      },
      openDialog (){
        if(this.Integrado){
          Swal.fire('Integração','<p>Para os sistemas integrados, as turmas são registrados no módulo de pedagogia.</p>','warning')
        }else{
            this.dialog = true
        }
      },
      loadclasse () {
       this.classesFiltered = this.classes.filter(c=>c.nivel === this.turma_obj.curso.nivel_ensino)
      },
      async initializeCursos () {
      try {
        this.isLoading = true
        this.cursos = await axios
          .get('/cursoFindAll')
          .then(res => res.data)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    async initializeTurmas () {
      try {
        this.isLoading = true
        this.turmas = await axios
          .get('/turmasFindAlls')
          .then(res => res.data)

          console.log(this.turmas);
        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    async initializeClasses () {
      try {
        this.isLoading = true
        this.classes = await axios
          .get('/classeFindAll2')
          .then(res => res.data)

        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    criarTurmaDescricao () {
      this.turma_obj.descricao = this.turma_obj.curso.descricao.trim()
      .toUpperCase()
      .substring(0, 3)
      .concat("-")
      .concat("SALA " + this.turma_obj.sala.padStart(2, "0") + "-")
      .concat(this.turma_obj.periodo.id + "-" + this.turma_obj.classe.descricao.trim()
      .toUpperCase()
      .substring(0, 3))
    },
    async Guardar () {

        try {
          this.overlay = true
          let params = {
              id:0,
              curso: this.turma_obj.curso.idCurso,
              classe: this.turma_obj.classe.pkAnoacademico,
              periodo: this.turma_obj.periodo.descricao,
              descricao: this.turma_obj.descricao,
              sala: this.turma_obj.sala,
              autor: ls.get('nomeUsuario')
          }

          let turmaExistente = this.turmas.filter( t=> t.descricao.toLowerCase() === (params.descricao+'/'+this.anolectivo).toLowerCase())
          if(turmaExistente.length){
              utilitarios.showAlertMessage('warning','Turma já foi registrada.')
          }else{


                let result = await axios.post('turmaInsertOne',params)
                if(result.data.affectedRows >= 1){
                  utilitarios.showAlertMessage('success','Turma registrada com sucesso.')
                  this.dialog = false
                  this.turma_obj = this.turma_objDefault
                  this.initializeTurmas()
                }else{
                  utilitarios.showAlertMessage('error','Ocorreu um erro ao tentar efectuar a operação.')
                }

          }
        } catch (error) {
          this.overlay = false
          utilitarios.showAlertMessage('error','Ocorreu um erro ao tentar efectuar a operação.')
        }finally{this.overlay = false}

    }
  }
  
 }
 </script>
 
<style scoped>
.bg {
 color:green;
 background: red
}

</style>
